module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-158ed1f9.png";